/* eslint-disable no-useless-escape */
import 'babel-polyfill';
import React from 'react';
import { CompositeDecorator } from 'draft-js';

const styles = {
	default: { backgroundColor: '#FFFF00' },
	menu2: { backgroundColor: 'rgba(82, 196, 26, 0.65)' },
	menu3: { backgroundColor: 'rgba(243, 171, 40, 0.65)' },
};

const SearchHighlight = props => {
	if (props.selectedMenu === '2') {
		return <span style={styles.menu2}>{props.children}</span>;
	} else if (props.selectedMenu === '3') {
		return <span style={styles.menu3}>{props.children}</span>;
	} else {
		return <span style={styles.default}>{props.children}</span>;
	}
};

export const generateDecorator = (highlightTerm, selectedMenu) => {
	return new CompositeDecorator([
		{
			strategy: (contentBlock, callback) => {
				if (highlightTerm.length > 0) {
					const _orgStr = highlightTerm.map(i => '([^\uac00-\ud7a3])' + i + '(?=[^\uac00-\ud7a3])');
					const regex = new RegExp(_orgStr.join('|'), 'g');
					const blockLength = contentBlock.getLength();
					let matchArr, start;
					while (
						(matchArr = regex.exec(' ' + contentBlock.getText().replace(/[\(\)]/, ' ') + ' ')) !== null
					) {
						start = matchArr.index;
						const end = Math.min(start + matchArr[0].trim().length, blockLength);
						// 앞뒤 공백을 덧댄 문자열에서 찾기 때문에 블록 범위를 벗어날 수 있다.
						if (start < end) callback(start, end);
					}
				}
			},
			component: SearchHighlight,
			props: { selectedMenu: selectedMenu },
		},
	]);
};
